import styled from 'styled-components';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';
import { style as styleConfig } from './config';

const { backgroundColor: backgroundColorConfig, textColor: textColorConfig } = styleConfig;

const StyledPromoIdentifier = styled.div.attrs({
	className: 'fuse-promo-identifier',
})`
	background-color: ${({ backgroundColor }) => backgroundColorConfig[backgroundColor]};
	padding-bottom: var(--spacing-global-space1);
	padding-top: var(--spacing-global-space1);
	text-align: center;
	width: 100%;
`;

const StyledPromoIdentifierText = styled(TypographyComponent).attrs({
	className: 'fuse-promo-identifier__text',
	'data-testid': 'fuse-promo-identifier__text',
})`
	margin: 0;
	color: ${({ textColor }) => textColorConfig[textColor]};
`;

export { StyledPromoIdentifier, StyledPromoIdentifierText };
